import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Flex, Box } from 'roo-ui/components';
import PulsingLoadingBlock from 'components/PulsingLoadingBlock';
import { mediaQuery } from 'lib/styledSystem';

const SummaryLoader = styled(Flex)`
  height: ${themeGet('space.6')};
  transition: all 0.2s ease-in-out 0.2s;
  opacity: ${(props) => (props.isLoading ? '1' : '0')};
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
`;

const SummaryResults = styled(Flex)`
  height: ${themeGet('space.4')};
  transition: all 0.2s ease-in-out 0;
  opacity: ${(props) => (props.isLoading ? '0' : '1')};
  font-size: ${themeGet('fontSizes.sm')};
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  ${mediaQuery.minWidth.sm} {
    transition: all 0.2s ease-in-out 0.2s;
  }
`;

const Summary = ({ isLoading, resultCount, totalPropertyCount }) => {
  const hasResults = resultCount > 0;
  const showingWithResults = hasResults ? 'Showing ' : '';
  const resultsShownCopy = `${showingWithResults}${resultCount} available out of ${totalPropertyCount} properties`;
  return (
    <Box mb={[4, 0, 0]} mt={[0, 6, 6]} position="relative">
      <SummaryResults isLoading={isLoading}>
        <Box data-testid="result-count">{resultsShownCopy}</Box>
      </SummaryResults>
      <Box display={['none', 'block']}>
        <SummaryLoader isLoading={isLoading}>
          <PulsingLoadingBlock height={14} width={50} mr={1} mb={0} />
          <PulsingLoadingBlock height={14} width={20} mr={1} mb={0} />
          <PulsingLoadingBlock height={14} width={100} mr={1} mb={0} />
          <PulsingLoadingBlock height={14} width={30} mb={0} />
        </SummaryLoader>
      </Box>
    </Box>
  );
};

Summary.propTypes = {
  resultCount: PropTypes.number.isRequired,
  totalPropertyCount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default Summary;
